import { type FC } from 'react';

import { type ViewModelProps } from '#packages/web/types/view-model-props';

import { NotFoundPageRenderer } from './not-found.renderer';
import { type NotFoundPageViewModel } from './not-found.view-model';

export type NotFoundPageContainerProps = ViewModelProps<NotFoundPageViewModel>;

export const NotFoundPageContainer: FC<NotFoundPageContainerProps> = () => (
  <NotFoundPageRenderer />
);
